angular.module('gym.setup').factory('UnitsService', function() {
  return {
    get: function() {
      var units;
      return units = {
        US: {
          currency: 'USD',
          mass: 'lb',
          measurement: 'in'
        },
        CA: {
          currency: 'CAD',
          mass: 'kg',
          measurement: 'cm'
        },
        MX: {
          currency: 'MXN',
          mass: 'kg',
          measurement: 'cm'
        },
        TT: {
          currency: 'TTD',
          mass: 'kg',
          measurement: 'cm'
        },
        AW: {
          currency: 'AWG',
          mass: 'kg',
          measurement: 'cm'
        },
        DO: {
          currency: 'DOP',
          mass: 'kg',
          measurement: 'cm'
        },
        GB: {
          currency: 'GBP',
          mass: 'lb',
          measurement: 'in'
        },
        NZ: {
          currency: 'NZD',
          mass: 'kg',
          measurement: 'cm'
        },
        AU: {
          currency: 'AUD',
          mass: 'kg',
          measurement: 'cm'
        },
        DK: {
          currency: 'DKK',
          mass: 'kg',
          measurement: 'cm'
        },
        RO: {
          currency: 'RON',
          mass: 'kg',
          measurement: 'cm'
        },
        IT: {
          currency: 'EUR',
          mass: 'kg',
          measurement: 'cm'
        },
        MV: {
          currency: 'MVR',
          mass: 'kg',
          measurement: 'cm'
        },
        AT: {
          currency: 'EUR',
          mass: 'kg',
          measurement: 'cm'
        },
        GR: {
          currency: 'EUR',
          mass: 'kg',
          measurement: 'cm'
        },
        SA: {
          currency: 'SAR',
          mass: 'kg',
          measurement: 'cm'
        },
        ZA: {
          currency: 'ZAR',
          mass: 'kg',
          measurement: 'cm'
        },
        KE: {
          currency: 'KES',
          mass: 'kg',
          measurement: 'cm'
        },
        AE: {
          currency: 'AED',
          mass: 'kg',
          measurement: 'cm'
        },
        JM: {
          currency: 'JMD',
          mass: 'kg',
          measurement: 'cm'
        },
        BH: {
          currency: 'BHD',
          mass: 'kg',
          measurement: 'cm'
        },
        TN: {
          currency: 'TND',
          mass: 'kg',
          measurement: 'cm'
        },
        PH: {
          currency: 'PHP',
          mass: 'kg',
          measurement: 'cm'
        },
        TH: {
          currency: 'THB',
          mass: 'kg',
          measurement: 'cm'
        },
        OM: {
          currency: 'OMR',
          mass: 'kg',
          measurement: 'cm'
        },
        MM: {
          currency: 'MMK',
          mass: 'lb',
          measurement: 'in'
        },
        CY: {
          currency: 'EUR',
          mass: 'kg',
          measurement: 'cm'
        },
        IE: {
          currency: 'EUR',
          mass: 'kg',
          measurement: 'cm'
        },
        BE: {
          currency: 'EUR',
          mass: 'kg',
          measurement: 'cm'
        },
        FI: {
          currency: 'EUR',
          mass: 'kg',
          measurement: 'cm'
        },
        FR: {
          currency: 'EUR',
          mass: 'kg',
          measurement: 'cm'
        },
        DE: {
          currency: 'EUR',
          mass: 'kg',
          measurement: 'cm'
        },
        LU: {
          currency: 'EUR',
          mass: 'kg',
          measurement: 'cm'
        },
        NL: {
          currency: 'EUR',
          mass: 'kg',
          measurement: 'cm'
        },
        ES: {
          currency: 'EUR',
          mass: 'kg',
          measurement: 'cm'
        },
        JP: {
          currency: 'JPY',
          mass: 'kg',
          measurement: 'cm'
        },
        IN: {
          currency: 'INR',
          mass: 'kg',
          measurement: 'cm'
        },
        PK: {
          currency: 'PKR',
          mass: 'kg',
          measurement: 'cm'
        },
        LT: {
          currency: 'EUR',
          mass: 'kg',
          measurement: 'cm'
        },
        MT: {
          currency: 'EUR',
          mass: 'kg',
          measurement: 'cm'
        },
        ID: {
          currency: 'IDR',
          mass: 'kg',
          measurement: 'cm'
        },
        MY: {
          currency: 'MYR',
          mass: 'kg',
          measurement: 'cm'
        },
        SG: {
          currency: 'SGD',
          mass: 'kg',
          measurement: 'cm'
        },
        HK: {
          currency: 'HKD',
          mass: 'kg',
          measurement: 'cm'
        },
        NO: {
          currency: 'NOK',
          mass: 'kg',
          measurement: 'cm'
        },
        SE: {
          currency: 'SEK',
          mass: 'kg',
          measurement: 'cm'
        },
        CH: {
          currency: 'CHF',
          mass: 'kg',
          measurement: 'cm'
        }
      };
    }
  };
});
